import React, { startTransition } from 'react';
import { Card, Typography, Divider, Row, Col, Button, Badge, Tag } from 'antd';
import { FilterOutlined, ClearOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { useFilterStore, useFilterActions } from '../../store/useFilters';
import { Ambassador } from '../../types';
import BusinessUnitFilter from './BusinessUnitFilter';
import ActivityFilter from './ActivityFilter';

const { Title, Text } = Typography;

interface FilterPanelProps {
  ambassadors: Ambassador[];
}

const FilterPanel: React.FC<FilterPanelProps> = ({ ambassadors }) => {
  const { 
    filters, 
    clearAllFilters, 
    getActiveFilterCount 
  } = useFilterStore();
  
  const { clearLocationFilter } = useFilterActions();

  const activeFilterCount = getActiveFilterCount();
  const hasActiveFilters = activeFilterCount > 0;
  const hasLocationFilter = filters.locationFilter && filters.locationFilter.length > 0;

  return (
    <Card
      title={
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', minHeight: '24px' }}>
          {hasActiveFilters ? (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Badge 
                  count={activeFilterCount} 
                  style={{ backgroundColor: '#52c41a' }}
                />
                <span style={{ fontSize: '13px', color: '#666' }}>
                  {activeFilterCount} filter{activeFilterCount > 1 ? 's' : ''} active
                </span>
              </div>
              <Button 
                size="small" 
                icon={<ClearOutlined />}
                onClick={() => startTransition(() => clearAllFilters())}
                type="text"
              >
                Clear All
              </Button>
            </>
          ) : (
            <span style={{ fontSize: '13px', color: '#999', fontWeight: 'normal' }}>
              Filters
            </span>
          )}
        </div>
      }
      size="small"
      style={{ height: '100%' }}
      styles={{ body: { padding: '16px', height: '100%', overflow: 'auto' } }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>


        {/* Business Unit Filter */}
        <div style={{ flexShrink: 0 }}>
          <Text strong style={{ fontSize: '13px', color: '#666', marginBottom: '8px', display: 'block' }}>
            Business Unit
          </Text>
          <BusinessUnitFilter ambassadors={ambassadors} />
        </div>

        <Divider style={{ margin: '16px 0', flexShrink: 0 }} />

        {/* Activity Filter - Extends to bottom */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <Text strong style={{ fontSize: '13px', color: '#666', marginBottom: '8px', display: 'block' }}>
            Activity
          </Text>
          <div style={{ flex: 1 }}>
            <ActivityFilter ambassadors={ambassadors} />
          </div>
        </div>

      </div>
    </Card>
  );
};

export default FilterPanel;